import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { InitialLoading } from '~/components/common';
import { PAGE_ROUTE, STORAGE } from '~/constants';
import { useAuthStore } from '~/store';

export default function PrivateRoute() {
  const { isInitialized, isAuthenticated } = useAuthStore();

  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);

  useEffect(() => {
    const redirectUrlFromSession = sessionStorage.getItem(
      STORAGE.AUTH.REDIRECT_AFTER_LOGIN,
    );

    if (redirectUrlFromSession) {
      setRedirectUrl(redirectUrlFromSession);
      sessionStorage.removeItem(STORAGE.AUTH.REDIRECT_AFTER_LOGIN);
    }
  }, []);

  if (!isInitialized) {
    return <InitialLoading />;
  }

  if (!isAuthenticated) {
    return <Navigate to={PAGE_ROUTE.SIGNIN_HOME} replace />;
  }

  return redirectUrl ? <Navigate to={`/${redirectUrl}`} replace /> : <Outlet />;
}
